import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {
  GenderEqualityScoreLabel,
} from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdGenderEqualityScore extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    fieldName:PropTypes.string
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <td
      styleName='col'
      onClick={() => { this.props.clickShareclass(this.props.shareclass) }}
    >
      <GenderEqualityScoreLabel
        fund={this.props.shareclass}
        gefType={this.props.fieldName}
      />
    </td>
  }
}
